// eslint-disable-next-line
UtmParams = {
  utmParams: {},
  getUtmParamsFromUrl: function () {
    const self = window.location.toString();
    const queryString = self.split('?');
    if (queryString.length > 1) {
      const pairs = queryString[1].split('&');
      for (let i = 0; i < pairs.length; i++) {
        const keyVal = pairs[i].split('=');
        if (keyVal[0].includes('utm')) {
          this.utmParams[keyVal[0]] = keyVal[1];
        }
      }
    }
  },
  saveParams: function () {
    this.getUtmParamsFromUrl();
    if (Object.keys(this.utmParams).length > 0) {
      const body = JSON.stringify({
        attributes: this.utmParams
      });
      // fetch(`${routes.cart_update_url}`, {
      fetch('/cart/update', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        ...{
          body
        }
      }).then(response => {
        return response.json();
      });
    }
  }
};
window.addEventListener('load', function () {
  // eslint-disable-next-line
  UtmParams.saveParams();
});